export default {
      id: "arrow-left-usage",
      viewBox: "0 0 41 32",
      url: __webpack_public_path__ + "img/icons.ec9c9113.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }